import type { GuessSide, MiniGameResult } from './types';

type Rng = () => number;

export function randomSide(rng: Rng = Math.random): GuessSide {
  return rng() < 0.5 ? 'left' : 'right';
}

export function resolveGuess(player: GuessSide, hidden: GuessSide): MiniGameResult {
  return player === hidden ? 'win' : 'lose';
}

export function guessReward(r: MiniGameResult): number {
  return r === 'win' ? 10 : 0;
}
